// extracted by mini-css-extract-plugin
export var activeEntry = "Sidebar-module--activeEntry--3d050";
export var activeParent = "Sidebar-module--activeParent--b151c";
export var collapsible = "Sidebar-module--collapsible--305ba";
export var collapsibleBody = "Sidebar-module--collapsibleBody--99bac";
export var collapsibleHeader = "Sidebar-module--collapsibleHeader--17ba5";
export var endpointPill = "Sidebar-module--endpointPill--c34f2";
export var itemsCategory = "Sidebar-module--itemsCategory--12b33";
export var level_1 = "Sidebar-module--level_1--4a0e1";
export var level_2 = "Sidebar-module--level_2--368f5";
export var level_3 = "Sidebar-module--level_3--4c24d";
export var level_4 = "Sidebar-module--level_4--f8cbf";
export var link = "Sidebar-module--link--5dde3";
export var sidebar = "Sidebar-module--sidebar--df0f6";
export var sidebarBody = "Sidebar-module--sidebarBody--25238";
export var sidebarHeader = "Sidebar-module--sidebarHeader--cd54c";
export var tag = "Sidebar-module--tag--9e2b2";
export var tagPill = "Sidebar-module--tagPill--7db75";
export var verb = "Sidebar-module--verb--31b1d";
export var verb_delete = "Sidebar-module--verb_delete--d00bb";
export var verb_get = "Sidebar-module--verb_get--941dc";
export var verb_options = "Sidebar-module--verb_options--44886";
export var verb_patch = "Sidebar-module--verb_patch--a5110";
export var verb_post = "Sidebar-module--verb_post--66ea9";
export var verb_put = "Sidebar-module--verb_put--ab1ad";